export const TOPIC_FILES_API_VIEW_REQUEST = "TOPIC_FILES_API_VIEW_REQUEST"
export const TOPIC_FILES_API_VIEW_SUCCESS = "TOPIC_FILES_API_VIEW_SUCCESS"
export const TOPIC_FILES_API_VIEW_FAILURE = "TOPIC_FILES_API_VIEW_FAILURE"
export const TOPIC_FILES_API_VIEW_CLEAR="TOPIC_FILES_API_VIEW_CLEAR"
